const getFlag = (short?: any) => {
  try {
    if (!short || typeof short !== 'string' || short.length !== 2)
      throw new Error('Invalid short code')

    const data = require(`world_countries_lists/data/flags/64x64/${short.toLowerCase()}.png`)
    if (typeof data === 'string') {
      return data
    }
    return data.default
  } catch (e) {
    return ''
  }
}

export default getFlag
